import { render } from "./TaxRulesList.vue?vue&type=template&id=6337d87d&ts=true"
import script from "./TaxRulesList.vue?vue&type=script&lang=ts"
export * from "./TaxRulesList.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\yellowrock\\yellowrockNew\\yellowrocknewshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__